import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, first, map } from 'rxjs';

import { DefaultRouteService } from '../../core/services/default-route.service';
import { selectStateDone } from '../../shared/utils';
import { authFeature } from '../store';

export const redirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const defaultRouteService = inject(DefaultRouteService);

    return inject(Store)
        .select(authFeature.selectActiveProfile)
        .pipe(
            filter(selectStateDone),
            first(),
            map((profile) => {
                if (state?.url === '/') {
                    return defaultRouteService.getDefaultRouteTree(profile.result);
                }

                return true;
            }),
        );
};
